<script>
import fileCode from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-code.svg'
import filePenLine from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-pen-line.svg'
import filePieChart from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-pie-chart.svg'
import fileSearch from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-search-2.svg'
import fileSliders from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-sliders.svg'
import fileStack from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-stack.svg'
import switchCamera from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/switch-camera.svg'
import undo from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/undo-2.svg'
import fileCog from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-cog.svg'
import foldersCog from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/folder-cog.svg'
import folders from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/folders.svg'
import userRoundCog from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/user-round-cog.svg'
import clipboardCheck from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/clipboard-check.svg'
import encerrarConversa from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/encerrar-conversa.svg'
import wap from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/wap.svg'
import filePause from '@/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-suspender.svg'

export default {

  data () {
    return {
      imagens: {
        fileCode,
        filePenLine,
        filePieChart,
        fileSearch,
        fileSliders,
        fileStack,
        switchCamera,
        undo,
        fileCog,
        foldersCog,
        folders,
        userRoundCog,
        clipboardCheck,
        encerrarConversa,
        wap,
        filePause
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/manutencao/mixin/IconMixin.vue